import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import React, { useState } from "react";
import "../modals/sessionExpireModal.css";
import "../analytics/analytics.css";
import { useAuth } from "../../context/API_Client";

export default function SessionExpiredModal({ open, setIsSessionModalOpen }) {

  const { logout } = useAuth();
  const [isOpen, setIsOpen] = useState(open);
  const handleClose = () => {
    setIsSessionModalOpen(false);
    setIsOpen(false);
  };
  const handleLoginClick = () => {
    logout();
    handleClose();
  };

  return (
    <>
      <Dialog className="sessionMain" open={open}>
        <div style={{ marginTop: "52px" }}>
          <img src="/assets/SessionExpiredImg.svg" alt="Session Expire" />
        </div>

        <DialogTitle className="font-black-highest headerH2Medium">
          Session Expired
        </DialogTitle>
        <DialogContent sx={{ flex: "initial !important" }}>
          <DialogContentText className="sessionExpireDescription bodyB2Regular font-black-medium">
            Your login session has expired.
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={handleLoginClick}
            variant="contained"
            className="sessionButton"
          >
            Login Again
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
